import React from 'react';

const SectionHeader = ({ eyebrow, title, description, align = 'left', className = '' }) => {
    const alignClasses = align === 'center' ? 'text-center items-center' : 'text-left items-start';
    return (
        <div className={`flex flex-col ${alignClasses} ${className}`}>
            {eyebrow && (
                <span className="badge-brand mb-3">{eyebrow}</span>
            )}
            <h2 className="text-3xl md:text-4xl font-bold text-ink-900 leading-tight">
                {title}
            </h2>
            <span className="accent-bar mt-4" />
            {description && (
                <p className="mt-4 text-ink-600 text-base md:text-lg leading-relaxed max-w-2xl">
                    {description}
                </p>
            )}
        </div>
    );
};

export default SectionHeader;
